module.exports = __webpack_public_path__ + "static/media/Trinket.7de1ee93.png";